// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9f1817dc] #app-content #app-content-wrapper .app-content-details{margin:0 auto;max-width:900px;display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
